/**
 * Phase 22 — the Hour Optimizer's rules as stored in hourOptimizerJson, the
 * old "Enough data" floor (`minBucketVolume`) read as its default rule "Not
 * enough data — Unique visits < 200 over the formula's first range →
 * Exclude". One reader for the planner and the editor.
 * For Media Devoted | Created By Ciro Autiero
 */
import { rulesWithLegacyFloor } from "../rules/default-rules";
import { parseRules } from "../rules/parse-rules";
import { DROP_GEN_HOUR_RULE_ACTIONS, DROP_GEN_HOUR_RULE_CHECK, type DropGenHourRuleAction, type DropGenRule } from "../rules/rules.types";
import type { DropGenHourOptimizerConfig } from "../types";

/** The old default floor — the default rule's number for a config saved before Phase 22. */
export const DEFAULT_HOUR_FLOOR = 200;

/** Stored hourOptimizerJson (any age, or nothing yet) → its rules, the default exclude rule included. */
export function hourRulesOf(stored: unknown): DropGenRule<DropGenHourRuleAction>[] {
  const o = typeof stored === "object" && stored !== null ? (stored as Record<string, unknown>) : {};
  // Hour rules may test hour tags (Tag Rules › Hours) — parsed with the hour check, never dropped.
  return parseRules(rulesWithLegacyFloor(o, "minBucketVolume", DEFAULT_HOUR_FLOOR), DROP_GEN_HOUR_RULE_ACTIONS, DROP_GEN_HOUR_RULE_CHECK);
}

/** The editor's settings from what is stored (any age, or nothing yet): defaults for what is missing, the
 *  old floor read as the default rule. The planner reads the same fields (backend parse-json). */
export function readHourOptimizer(stored: unknown): DropGenHourOptimizerConfig {
  const o = typeof stored === "object" && stored !== null ? (stored as Record<string, unknown>) : {};
  const { minBucketVolume: _floor, ...rest } = o;
  return { enabled: false, lookbackPreset: "last-14-days", minIntervalMin: 20, maxExtraSlots: 4, ...rest, rules: hourRulesOf(o) } as DropGenHourOptimizerConfig;
}
